import React, { useEffect, useState } from "react";
import {showToast, TOAST_TYPE} from "deskera-ui-library";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubmittedRecords, selectSubmittedRecords } from "../../../../../Redux/Slices/AISSubmissionSlice";
import Utility, { deepClone } from "../../../../../utility/Utility";
import MaskInputUtil from "../../../../../SharedComponents/MaskInput/MaskInputUtil";
import TenantManager from "../../../../../managers/TenantManager";
import { aisSummaryColumnConfig, parseVisibleColumnConfig } from "../../../../configs/config";
import {TableManger, TABLES} from "../../../../../managers/TableManger"
import DataGridHolderPayroll from "../../../../common/DataGridHolderPayroll";


const IRASSubmittedFile = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    /**Hooks */
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails)
    const [reload, setReload] = useState(false);
    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
      setMask(mask);
      setReload(!reload);
    });
    const [employee, setEmployee] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(20);
    const [requestParameter, setRequestParameter] = useState(props?.data?.params);

    /**Selectors */
    const summaryDetails = useSelector(selectSubmittedRecords);

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        if(props?.data?.isUpdateTrigerred) {
            loadAISSummittedDetailsData(props?.data?.params)
        }
    },[props])

    useEffect(() => {
        if(!Utility.isEmpty(summaryDetails)) {
            const { employee, filterConfig, cpfAccountId } = summaryDetails;
            const rowData = aisSummaryColumnConfig(
                employee,
                tenantDetails,
                mask
            );
            let columns = TableManger.getTableColumns(TABLES.PEOPLE_IRAS_AIS_SUBMISSION);
            let employeeColumn = parseVisibleColumnConfig(columns);
            const passingData = {
                columnData: deepClone(employeeColumn),
                rowData,
                filter: [],
                originalData: rowData,
              };
            setEmployee(passingData);
            setTotalPageCount(parseInt(filterConfig.totalPage));
            setCurrentPage(parseInt(filterConfig.page));
            setTotalCount(parseInt(filterConfig.numberOfRecords));
        }

    },[summaryDetails]);

    const loadAISSummittedDetailsData = async (config) => {
        try{
            const configDetail = {
                Limit: config.limit,
                CurrentPage: config.page,
                field: config.field,
                order: config.order,
                cpfAccountId: config.cpfAccountId,
                year: config.year
              };
            await dispatch(fetchSubmittedRecords(configDetail))
        }catch(err) {
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        }
    }

    return(
        <>
            <div className="column parent-width flex-1">
            <div className="column mt-l parent-width mb-s position-relative flex-1">
              <DataGridHolderPayroll
                tableName={""}
                displayTableName={""}
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowColumnAdd={false}
                // onSelection={(data)=>{
                //   selectedRow = data
                // }}
                gridData={employee}
                onPaginationClick={(requestedPageNumber) => {
                  const config = {
                    currentPage: requestedPageNumber,
                  };
                  loadAISSummittedDetailsData(config);
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={false}
                contextMenu={false}
                isMenuVisible={false}
                allowRowEdit={false}
                showContextEdit={false}
              />
            </div>
          </div>
        </>
    )

}

export default IRASSubmittedFile;